import React, { useEffect } from 'react';
import './style.scss';

export interface UQToastProps {
  id: string;
  type?: 'error' | 'warning' | 'info' | 'success';
  title?: string;
  content: string;
  duration?: number;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  onClose: (id: string) => void;
}

const Toast: React.FC<UQToastProps> = ({ id, type = 'info', title, content, duration, position = "bottom-right", onClose }) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => onClose(id), duration);
      return () => clearTimeout(timer);
    }
  }, [id, duration, onClose]);

  return (
    <div className={`uq-toast uq-toast-${type}`}>
      <div className="uq-toast-header">
        <span className="uq-toast-title">{title || type.charAt(0).toUpperCase() + type.slice(1)}</span>
        <button className="uq-toast-close" onClick={() => onClose(id)}>
          &times;
        </button>
      </div>
      <div className="uq-toast-content">{content}</div>
    </div>
  );
};

export default Toast;
